<template>
  <div ref="sidebar" id="sidebar">
    <div class="sidebar_content sidebar_head">
      <feather-icon
        @click="hiddenModal()"
        icon="XIcon"
        svgClasses="h-6 w-6 head_icon"
      />
      <h1 class="head_title">Publicación 345678908MDG</h1>
    </div>
    <div class="sidebar_content sidebar_body">
      <div class="body_title-wrapper">
        <p v-if="!dataAdd.active" class="title_text">Agregar dimensiones</p>
        <p v-else class="title_text">Activar flete dinámico</p>
      </div>
      <div class="body_footer">
        <div class="footer__text-wrapper footer__text--no-bold--input">
          <!-- <p class="footer_text-left">Paquete 1</p> -->
        </div>
        <div class="inputs__wrapper">
        <p class="inputs__text">Alto (cm)</p>
          <input
            v-model="body.height"
            class="inputs__modals"
            type="text"
            placeholder="Alto (cm)"
          />
          <p class="inputs__text">Ancho (cm)</p>
          <input
            v-model="body.width"
            class="inputs__modals"
            type="text"
            placeholder="Ancho (cm)"
          />
          <p class="inputs__text">Largo (cm)</p>
          <input
            v-model="body.depth"
            class="inputs__modals"
            type="text"
            placeholder="Largo (cm)"
          />
          
          
          <p class="inputs__text">Peso (g)</p>
          <input
            v-model="body.weight"
            class="inputs__modals"
            type="text"
            placeholder="Peso (g)"
          />
          <button
            :disabled="isDisabled"
            v-if="!dataAdd.active"
            @click="handleSubmit"
            :class="{
              button__modals: !isDisabled,
              'button__modals disabled': isDisabled,
            }"
          >
            Guardar dimensiones
          </button>
          <button v-else @click="handleSubmit" class="button__modals">
            Activar
          </button>
        </div>
      </div>
    </div>
     <div class="sidebar_content sidebar_body">
      <div class="body_title-wrapper">
        <p class="title_text"><strong>Dimensiones maximas: </strong></p>
      </div>

      <div class="body_footer">
        <div class="footer__text-wrapper footer__text--no-bold">
          <p>Alto: 500 cm</p>
          <p>Ancho: 500 cm</p>
          <p>Largo: 500 cm</p>
          <p>Peso: 500000 gr = 500 kg</p>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import Notifications from "../../../components/notifications/Notifications.vue";
import {
  splitDimensions,
  validateDimensions,
} from "../../../utils/publications";
import { showError, showSuccess } from "../../../services/alert.service";
import {
  updateDimensions,
  updateDimensionsFreight,
} from "../../../services/publications.service";
export default {
  name: "PublicationsAdd",
  props: {
    dataAdd: Object,
  },
  components: {
    Notifications,
    showError,
    showSuccess,
  },
  data() {
    return {
      body: {
        weight: "",
        height: "",
        width: "",
        depth: "",
      },
    };
  },
  mounted() {
    document.getElementById("sidebar").classList.add("show");
    if (this.dataAdd.shipping_dimensions) {
      this.body = splitDimensions(this.dataAdd.shipping_dimensions);
    }
  },
  computed: {
    isDisabled() {
      if (
        this.body.weight &&
        this.body.height &&
        this.body.width &&
        this.body.depth
      ) {
        return false;
      }
      return true;
    },
  },
  methods: {
    hiddenModal() {
      document.getElementById("sidebar").classList.remove("show");
      this.$emit("dataAdd");
    },
    handleSubmit() {
      const body = {
        ...this.body,
        meli_id: this.dataAdd.meli_id,
      };

      if (this.dataAdd.active) {
        // Active dynamic freight
        this.putDimensionsFreight(body, true);
      } else {
        // Update dimensions
        this.putDimensionsFreight(body);
      }
    },
    async putDimensionsFreight(body, dynamic = false) {
      try {
        validateDimensions(body);
        const result = dynamic
          ? await updateDimensionsFreight(body)
          : await updateDimensions(body);
        console.log(result);
        showSuccess({ message: "¡Los cambios han sido guardados con éxito!" });
        this.hiddenModal();
      } catch (error) {
        console.log(error.message);
        const message =
          error.message ||
          "No pudimos guardar los cambios. Por favor, inténtalo de nuevo.";
        showError({ message });
      }
    },
  },
};
</script>
